<template>
  <v-container fluid class="creativeproject-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Creative Project</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Project</p>
                        <v-select
                          class="mb-4"
                          :items="['Branding', 'Design', 'Writing']"
                          v-model="creativeproject.projectchannel"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the project channel">
                        </v-select>
                        <v-select
                          v-if="creativeproject.projectchannel=='Writing'"
                          class="mb-4"
                          :items="languages.filter(language=>language.languagestatus!='Inactive').map(x => {return {text: x.languagename, value: x.languagecode}})"
                          v-model="creativeproject.languagecode"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Language"
                          persistent-hint
                          single-line hint="Please choose the language">
                        </v-select>
                        <v-select
                          v-if="creativeproject.projectchannel=='Design' || creativeproject.projectchannel=='Branding'"
                          class="mb-4"
                          :items="getFormats()"
                          v-model="creativeproject.projectformat"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Format"
                          persistent-hint
                          single-line hint="Please choose the format">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=creativetypes[creativeproject.projectchannel]
                          v-model="creativeproject.projecttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the project type">
                        </v-select>
                        <v-menu
                          ref="new_projectreqdate"
                          v-model="new_projectreqdate"
                          :close-on-content-click="false"
                          :return-value.sync="creativeproject.projectreqdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              persistent-hint
                              v-model="creativeproject.projectreqdate"
                              label="Completion Date"
                              v-bind="attrs"
                              v-bind:value="creativeproject.projectreqdate"
                              v-bind:error="errorindex == 3"
                              v-on="on"
                              single-line hint="Please choose the request completion date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="creativeproject.projectreqdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="new_projectreqdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.new_projectreqdate.save(creativeproject.projectreqdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="mktprojects.filter(project=>project.projectstatus!='Inactive').map(x => {return {text: x.projectname, value: x._id};})"
                          v-model="creativeproject.mktprojectid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Project"
                          persistent-hint
                          single-line hint="Please choose the marketing project">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="[]"
                          v-model="creativeproject.bizprojectid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Project"
                          persistent-hint
                          single-line hint="Please choose the business project">
                        </v-select>
                      </v-form>
                    </v-col>                                     
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <v-form>
                        <v-text-field
                          class="mb-4"
                          v-model="creativeproject.projectname"
                          v-bind:error="errorindex == 6"
                          dense
                          placeholder="Project Name"
                          persistent-hint>
                        </v-text-field>
                        <label>
                          <h6>Project Description & Details</h6> 
                        </label>
                        <vue-editor v-model="creativeproject.projectdesc"></vue-editor>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            @click="Done"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Profile or Sample Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept=".jpg, .gif, .png" hint="jpg, gif, png" persistent-hint />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertCreativeProject()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      error: undefined,
      errortag: false,
      errorindex: undefined,
      imageurl: undefined,
      new_projectreqdate: false,
      mktprojects: [],
      step: 1,
      creativeproject: {},
      creativetypes: {
        Branding: ['Creative Content', 'Brand Guidebook', 'TVC Storyboard', 'Photo Moodboard'],
        Design:  ['Artwork & Illustration', 'Social Media Design', 'Packaging Design', 'Print Design', 'Logo Design', 'Animation', 'Artwork Retrieval'],
        Writing: ['Content Writing', 'Translation', 'Editing & Proofreading'],
      },
      designformats: [
        "Facebook Post Square 1080 x 1080",
        "Facebook Post Landscape 1200 x 630",
        "Facebook Post Landscape 940 x 788",
        "Facebook Story 1080 x 1920",
        "Instagram Post Square 1080 x 1080",
        "Instagram Post Portrait 1080 x 1350",
        "Instagram Reel 1080 x 1920",
        "TikTok Photo Square 1080 x 1080",
        "TikTok Photo 3:4 960 x 1280",
        "TikTok Story 1080 x 1920",
        "Other Format"
      ],
      brandingtypes: {
        'Creative Content': ['Blog Article', 'Set of 2 Social Media Posts', 'Set of 5 Social Media Posts', 'Set of 10 Social Media Posts', 'Set of 15 Social Media Posts'],
        'Brand Guidebook':  ['Standard Guidebook', 'Other Format'],
        'TVC Storyboard': ['Standard 1 concept', 'Standard 2-3 concepts', 'Other Format'],
        'Photo Moodboard': ['Standard 1 concept', 'Standard 2-3 concepts', 'Other Format'],
      },
      brandingformats: [
        "",
        "",
        "",
        "",
      ]
    }
  },
  computed: {
    ...mapState('MarketProject', ['projects']),
    ...mapState('CreativeProject', ['isReceiving']),
    ...mapState('Language', ['languages']),
  },
  methods: {
    ...mapActions('MarketProject', ['getMarketProjectsAllRequest']),
    ...mapActions('CreativeProject', ['getCreativeProjects', 'insertCreativeProjectRequest', 'insertCreativeProjectWithImageRequest']),
    ...mapActions('Language', ['getLanguagesRequest']),
    checkError(){
      if(!this.creativeproject.projectchannel){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(this.creativeproject.projectchannel=='Writing' && (this.creativeproject.languagecode==null || this.creativeproject.languagecode==undefined)){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.creativeproject.projecttype){
        this.errortag = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.creativeproject.projectreqdate){
        this.errortag = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.creativeproject.mktprojectid){
        this.errortag = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.creativeproject.projectname){
        this.errortag = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.creativeproject.projectdesc){
        this.errortag = true;
        this.errorindex = 7;
        return false;
      }

      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else router.replace({ name: 'Dashboard' });
    },
    async insertCreativeProject() {
      if(this.creativeproject.projectchannel=='Design') this.creativeproject.languagecode=null;
      if(this.creativeproject.imagefile!=null) await this.insertCreativeProjectWithImageRequest(this.creativeproject);
      else await this.insertCreativeProjectRequest(this.creativeproject);
      this.Done();
    },
    onFileChange(file) {
      if (!file) {return;}
      this.creativeproject.imagefile = file;
      this.creativeproject.imagename = file.name;
      this.createImage(file);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
    getFormats(){
      if(this.creativeproject.projectchannel=='Design') return this.designformats;
      if(this.creativeproject.projectchannel=='Branding' && this.creativeproject.projecttype!=null) return this.brandingtypes[this.creativeproject.projecttype];
      return []
    }
  },
  async created () {
    this.initvalue = this.$route.params;
    this.mktprojects = await this.getMarketProjectsAllRequest();
    if(this.languages.length==0) await this.getLanguagesRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
